import momomoment from 'moment'
import { CountryCode } from './countryCodes'
import mapCodeToMomentLocale, {
  mapCodeToMomentCode,
} from './mappers/mapCodeToMomentLocale'

export async function switchDateLanguage(language: CountryCode) {
  await mapCodeToMomentLocale(language)
  const localeString = mapCodeToMomentCode(language)

  momomoment.locale(localeString)
}

export function moment() {
  return momomoment
}
